import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

type OrderValidationDialogProps = {
    isOpen: boolean;
    message: string;
    showConfirmButton: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export const OrderValidationDialog = ({
    isOpen,
    message,
    showConfirmButton,
    onClose,
    onConfirm,
}: OrderValidationDialogProps) => {
    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, color: "error.main" }}>
                <ErrorOutlineIcon />
                Atenção
            </DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    {showConfirmButton ? "Cancelar" : "Fechar"}
                </Button>
                {showConfirmButton && (
                    <Button variant="contained" color="primary" onClick={onConfirm}>
                        Continuar
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

